import { createReducer } from 'redux-act';

import {
  EDITOR_CLEAR_DATA,
  EDITOR_FETCH_DATA_FAIL,
  EDITOR_FETCH_DATA_INIT,
  EDITOR_FETCH_DATA_SUCCESS
} from 'state/actions/editors';

const initialState = {
  shapes: new Map(),
  shapesByPoiId: new Map(),
  shapeList: [],
  model3dList: [],
  loading: false,
  error: {
    errors: null,
    message: ''
  },
  success: false
};

export const editorsReducer = createReducer(
  {
    [EDITOR_FETCH_DATA_INIT]: (state) => ({
      ...state,
      loading: true
    }),
    [EDITOR_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      shapes: payload.shapes,
      shapesByPoiId: payload.shapesByPoiId || new Map(),
      shapeList: payload.shapeList,
      model3dList: payload.model3ds,
      loading: false,
      error: {
        errors: null,
        message: ''
      }
    }),
    [EDITOR_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [EDITOR_CLEAR_DATA]: () => ({
      ...initialState
    })},
    initialState
);
